<template>
  <v-list
    v-if="notificationList.length != 0"
    subheader
    two-line
    height="450"
    :style="{ 'overflow-y': scrollList }"
  >
    <v-list-item
      v-for="notification in notificationList"
      :key="notification.id"
      @click="
        $router.push({
          name: 'NotificationDetailView',
          params: {
            id: notification.id,
          },
        })
      "
    >
      <v-tooltip
        top
        :content-class="
          isGroup(notification.managerRef) ? 'tooltip-no-transparency' : ''
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="{
              ...on,
              mouseenter: (e) => onActivatorMouseEnter(e, notification, on),
            }"
          >
            <AppAvatar
              v-if="notification.manager"
              :userName="fullName(notification.manager)"
              :userAvatar="notification.manager?.avatarURL"
              :isGroup="isGroup(notification.managerRef)"
              :avatarSize="isGroup(notification.managerRef) ? '34' : '30'"
              :initialsSize="isGroup(notification.managerRef) ? 11 : 14"
              fab
              small
              iconSize="24"
              avatarColor="primary"
              initialsColor="secondary"
              :showWarn="
                notification.manager.disabled || !notification.managerAccepted
              "
              :overlapIconColor="notification.overlapIconColor"
            />
          </span>
        </template>
        <!-- Contenido del tooltip -->
        <div v-if="isGroup(notification.managerRef)">
          <div>
            <span>{{ $t('group') }}: {{ fullName(notification.manager) }}</span>
          </div>
        </div>
        <div v-else>
          {{ fullName(notification.manager) }}
        </div>

        <div v-if="!notification.managerAccepted">
          <div v-if="isGroup(notification.managerRef)">
            {{ $t('waitGroupManager') }}
          </div>
          <div v-else>
            {{ $t('waitManager') }}
          </div>
        </div>

        <div v-if="notification.manager.disabled">
          {{ $t('userDisabled') }}
        </div>

        <!--Mostrar lista de operadores del grupo responsable -->
        <div v-if="isGroup(notification.managerRef)">
          <div style="display: block; margin-top: 8px; margin-bottom: 10px">
            {{ $t('groupOperators') }}:
          </div>

          <!-- estado: cargando -->
          <div v-if="!notification.groupTooltipReady" class="tooltip-loading">
            <v-progress-circular indeterminate size="20" width="2" />
          </div>

          <!-- estado: cargado -->
          <template v-else>
            <!-- si hay hay operadores -->
            <!-- mostrar avatar y nombre de los primeros N operadores del grupo -->
            <ul v-if="notification.groupOperators?.length">
              <li
                v-for="(operator, index) in notification.groupOperators.slice(
                  0,
                  maxOperatorsPreview
                )"
                :key="index"
              >
                <v-row align="center">
                  <AppAvatar
                    class="mr-2 mt-3 mb-3"
                    :userName="fullName(operator)"
                    :userAvatar="operator.avatarURL"
                    :avatarSize="isGroup(notification.managerRef) ? '34' : '30'"
                    :initialsSize="isGroup(notification.managerRef) ? 11 : 14"
                    iconSize="24"
                    avatarColor="primary"
                    initialsColor="secondary"
                    :showWarn="operator.disabled || !operator.canBeManager"
                    :overlapIconColor="
                      getOverlapIconColorOperatorTooltip(operator)
                    "
                  />

                  <span class="mr-2 mt-3 mb-3">
                    {{ fullName(operator) }} :
                    {{ operatorAccessText(operator) }}
                    <template
                      v-if="hasOperatorResponded(notification, operator)"
                    >
                      <v-icon
                        :color="getResponseColor(notification, operator)"
                        size="15"
                        class="ml-1 mb-1"
                      >
                        mdi-circle
                      </v-icon>
                      {{ operatorRespondedText(notification, operator) }}
                    </template>
                  </span>
                </v-row>
              </li>
              <br />
            </ul>
            <!-- Texto informativo, dentro del tooltip, cuando hay mas operadores de los mostrados -->
            <div
              v-if="notification.groupOperators?.length > maxOperatorsPreview"
              class="group-operators-info"
            >
              <v-chip
                small
                _color="grey lighten-4"
                _text-color="grey darken-3"
                color="primary"
                text-color="seconday"
                class="operator-count-chip"
              >
                +{{ notification.groupOperators.length - maxOperatorsPreview }}
              </v-chip>
              <span class="operator-count-text">{{
                $t('groupOperators')
              }}</span>
            </div>

            <!-- estado: cargado pero grupo vacio -->
            <div v-if="!notification.groupOperators?.length">
              <ul>
                <li>{{ $t('withoutOperators') }}</li>
              </ul>
            </div>
          </template>
        </div>
      </v-tooltip>

      <v-chip
        class="white--text mr-3 ml-3"
        :color="getNotificationStatus(notification).color"
      >
        <v-icon :class="getNotificationStatus(notification).color" dark>
          {{ getNotificationType(notification).icon }}
        </v-icon>
        <span class="ml-1">{{
          $t(getNotificationStatus(notification).status)
        }}</span>
      </v-chip>
      <div class="ml-3 mr-3 subtitle">
        {{ $d(notification.fecha_puesta_disposicion, 'i18nDate') }}
      </div>
      <v-list-item-content>
        <v-list-item-title>
          {{ notification.nombre_organismo_emisor }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ notification.nombre_organismo_emisor_raiz }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-container v-else style="text-align: center">
    <b>
      <span> {{ $t('emptyTypeNotificationList') }} </span>
    </b>
  </v-container>
</template>
<script>
import {
  getNotificationStatus,
  getNotificationType,
  canOperatorBeManager,
} from '@/services/notification-service'
import { isGroupRef } from '@/services/user-service'
import { getGroup, getGroupOperators } from '@/services/groups-service'
import { mapGetters } from 'vuex'

export default {
  props: {
    notificationList: {
      type: Array,
    },
  },
  methods: {
    getNotificationStatus(notification) {
      return getNotificationStatus(notification)
    },
    getNotificationType(notification) {
      return getNotificationType(notification)
    },
    isGroup(ref) {
      return isGroupRef(ref)
    },
    fullName(obj, nameKey = 'name', surnameKey = 'surname') {
      if (!obj) return ''
      if (obj.fullName) return obj.fullName

      return [obj[nameKey], obj[surnameKey]]
        .filter((value) => typeof value === 'string' && value.trim() !== '')
        .join(' ')
    },
    async groupOperators(ref) {
      // Devuelve los operadores de un grupo
      const group = await getGroup(ref)
      if (!group?.usersRef?.length) return []
      return await getGroupOperators(group.usersRef)
    },
    async canOperatorAccessToNotification(operator, notification) {
      // Segun las especificaciones de la tarea GOODOK-2039 si el responsable es un grupo y el operador
      // pertenece a ese grupo debe tomar en cuenta solo las empresas, y no aplicar tambien los filtros.
      const canBeManager = canOperatorBeManager(operator, notification)

      return canBeManager && !operator.disabled
    },
    async loadGroupData(item) {
      if (!item.managerRef || !this.isGroup(item.managerRef)) return

      // Si ya esta cargado volver a calcular los permisos igualmente, no guardar nada en cache
      // Estado inicial, aun no cargado (reactivo)
      this.$set(item, 'groupOperators', undefined)
      this.$set(item, 'groupOperatorsLoaded', false)
      this.$set(item, 'groupTooltipReady', false)
      this.$set(item, 'overlapIconColor', 'loading')

      try {
        const operatorsRaw = await this.groupOperators(item.managerRef)

        // clonar y no modificar el objeto devuelto por el servicio
        const operators = operatorsRaw.map((op) => ({
          ...op,
          canBeManager: null,
        }))

        // Añadirlo como nuevo atributo de la notificacion
        item.groupOperators = operators || []

        // Calcular el acceso a la notificacion
        await this.loadGroupOperatorsAccess(item)

        item.groupOperatorsLoaded = true // Finalizada la carga de operadores de esta notificacion
        item.groupTooltipReady = true // El tooltip ya puede ser mostrado, evita flashes
        item.overlapIconColor = this.calculateOverlapIconColor(item) // Estado del avatar del grupo
      } catch (e) {
        console.error('Error cargando operadores del grupo', e)
        item.groupOperators = []
        item.groupOperatorsLoaded = true
        item.groupTooltipReady = true
        item.overlapIconColor = 'error'
      }
    },
    async loadGroupOperatorsAccess(item) {
      if (!this.isGroup(item.managerRef)) return
      if (!item.groupOperators?.length) return

      // Marcar todos como loading
      item.groupOperators.forEach((operator) => {
        this.$set(operator, 'canBeManager', 'Procesando ...')
      })

      try {
        await Promise.all(
          item.groupOperators.map(async (operator) => {
            const result = await this.canOperatorAccessToNotification(
              operator,
              item
            )
            operator.canBeManager = result
          })
        )
      } catch (e) {
        console.error('Error comprobando accesos del grupo', e)
        item.groupOperators.forEach((operator) => {
          operator.canBeManager = false
        })
      }
    },
    operatorAccessText(operator) {
      if (
        operator.canBeManager === null ||
        operator.canBeManager === 'Procesando ...'
      ) {
        return this.$t('processing')
      }
      if (operator.disabled) return this.$t('operatorDisabled')
      return operator.canBeManager
        ? '' //this.$t('operatorAccessNotificationOK') // por defecto, si tiene acceso no pinta ningun texto
        : this.$t('operatorAccessNotificationKO')
    },
    onActivatorMouseEnter(e, item, on) {
      on.mouseenter(e) // asegura que Vuetify abra el tooltip
      this.managerTooltipMouseEnter(item) // dispara la carga personalizada en paralelo
    },
    managerTooltipMouseEnter(item) {
      // nota: usar setTimeout dentro de la funcion js, no en el template
      setTimeout(() => {
        this.loadGroupData(item)
      }, 0)
    },
    calculateOverlapIconColor(item) {
      // Un operador ya aceptó ser responsable, no hay que mostrar ningun warning ni error
      if (item.managerAccepted) return undefined

      // Si no es grupo, comportamiento normal de usuario
      if (!this.isGroup(item.managerRef)) {
        return item.manager?.disabled
          ? 'error'
          : !item.managerAccepted
          ? 'warning'
          : undefined
      }

      // Es un grupo, pero no hay operadores cargados todavia
      if (!item.groupOperatorsLoaded) return undefined

      // operadores cargados y grupo vacio
      if (!item.groupOperators.length) return 'error'

      const operators = item.groupOperators
      // Mientras se calculan los permisos, no establecer como error
      const isLoading = operators.some(
        (op) => op.canBeManager === 'Procesando ...'
      )
      if (isLoading) {
        return 'loading'
      }

      // Si ningun operador tiene acceso a la notificacion, establecer como error
      const hasAccess = operators.some((op) => op.canBeManager === true)
      if (!hasAccess) return 'error'

      const responses = item.responseOperators || []

      // Operadores que pertenecen al grupo y que pueden responder
      const eligibleOperators = operators.filter(
        (op) => !op.disabled && op.canBeManager === true
      )

      // Operadores que ya han rechazado ser responsable
      const rejectedOperators = responses.filter((r) => r.response === false)

      // Todos han rechazado
      const rejectedAll =
        eligibleOperators.length > 0 &&
        rejectedOperators.length === eligibleOperators.length

      if (rejectedAll) return 'error'

      // Todavia hay operadores pendientes de responder
      return 'warning'
    },
    getOverlapIconColorOperatorTooltip(operator) {
      // Para cada operador del grupo responsable
      if (operator.disabled || operator.canBeManager === false) return 'error'
      return operator.canBeManager ? undefined : 'warning'
    },
    hasOperatorResponded(item, operator) {
      if (!operator) return false
      return item?.responseOperators?.some((r) => r.userRef.id === operator.id)
    },
    getLatestOperatorResponse(notification, operator) {
      return this.getOperatorResponses(notification, operator)?.latest ?? null
    },
    getOperatorResponses(notification, operator) {
      // ahora un operador puede tener mas de una respuesta (p.e. rechazar y despues aceptar)
      // devuelve el objeto con la info necesaria: quién, qué y cuándo
      if (!notification.responseOperators?.length) {
        return { latest: null, history: [] }
      }

      const responses = notification.responseOperators
        .filter((r) => r.userRef.id === operator.id)
        .slice() // copia defensiva, evita mutar el array original
        .sort((a, b) => b.createdAt - a.createdAt) // mas reciente arriba

      return {
        latest: responses[0] ?? null,
        history: responses.slice(1),
      }
    },
    getResponseColor(item, operator) {
      if (operator.disabled) return ''
      const found = this.getLatestOperatorResponse(item, operator)
      return found
        ? found.response === false
          ? 'error'
          : 'success'
        : 'undefined'
    },
    operatorRespondedText(item, operator) {
      const found = this.getLatestOperatorResponse(item, operator)
      if (!found) return ''
      let msg = ''
      if (found.response === false)
        msg = this.$t('operatorResponsabilityRejected')
      if (found.response === true)
        msg = this.$t('operatorResponsabilityAccepted')

      // esta almacenada en milisegundos
      const created = found.createdAt ? this.formatDate(found.createdAt) : ''
      return msg + ' (' + created + ')'
    },
    formatDate(ts) {
      if (!ts) return ''
      const d = new Date(ts)
      const pad = (n) => String(n).padStart(2, '0')

      return (
        `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ` +
        //`${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        `${pad(d.getHours())}:${pad(d.getMinutes())}`
      )
    },
  },
  computed: {
    ...mapGetters(['maxOperatorsPreview']),
    scrollList() {
      return this.notificationList.length > 5 ? 'scroll' : 'hidden'
    },
  },
}
</script>
<style lang="scss" scoped>
/* tooltip de grupo: color gris un poco mas oscuro y eliminar la transparencia */
.tooltip-no-transparency {
  background-color: rgba(97, 97, 97, 1) !important; /* opaco */
  opacity: 1 !important; /* sin transparencia */
  color: #ffffff; /* texto base legible */
}

.group-operators-info {
  display: flex;
  align-items: center; /* Alinea chip y texto verticalmente */
  margin-top: 12px; /* Igual que mt-3 */
  padding-left: 8px; /* Ajusta al borde izquierdo del tooltip */
}

.operator-count-chip {
  margin-right: 8px; /* espacio entre chip y texto */
}

.operator-count-text {
  font-size: 0.875rem; /* Igual que body-2, ajustable */
  color: #ffffff; /* texto base legible */
}

.tooltip-loading {
  min-width: 260px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
